import * as yup from 'yup';
import { alphabetRegix, alphaNumericRegix } from '../utils/functions';

export const signature_card_schema = {
  account_one_management: '',
  account_two_management: '',
  authorized_one_full_fame: '',
  authorized_two_full_fame: '',
  authorized_one_national_id_passport_no: '',
  authorized_two_national_id_passport_no: '',
  termsand_conditions: [],
};

// // Define schema for a single signatory
export const signature_card_validation_schema = yup.object().shape({
  fullNameOne: yup
    .string()
    .required('full_name_is_required')
    .matches(alphabetRegix, 'must_be_alphabetic'),
  identificationNoOne: yup
    .string()
    .min(10, 'valid_number')
    .required('required')
    .matches(alphaNumericRegix, 'only_alpha_Numeric_allowed'),
  accountManagementOne: yup.number().required('account_management_required'),

  accountManagementOtherOne: yup.string().when('accountManagementOne', {
    is: (val) => Number(val) === 1091,
    then: (schema) => schema.required('please_specify'),
    otherwise: (schema) => schema.notRequired(),
  }),

  fullNameTwo: yup
    .string()
    // .required('full_name_is_required')
    .matches(alphabetRegix, 'must_be_alphabetic'),
  identificationNoTwo: yup
    .string()
    .min(10, 'valid_number')
    // .required('required')
    .matches(alphaNumericRegix, 'only_alpha_Numeric_allowed'),
  accountManagementTwo: yup.number(),
  // .required('account_management_required'),

  accountManagementOtherTwo: yup.string().when('accountManagementTwo', {
    is: (val) => Number(val) === 1091,
    then: (schema) => schema.required('please_specify'),
    otherwise: (schema) => schema.notRequired(),
  }),

  // isAgreeToTheTermsAndCondition: yup
  //   .bool()
  //   .oneOf([true], 'please_agree_to_terms'),
  isAgreeToTheTermsAndCondition: yup
    .boolean()
    .required('please_agree_to_terms')
    .oneOf([true], 'please_agree_to_terms')
});
